(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lch-nav-item"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__lchNavInit) return;
  window.__lchNavInit = true;
  function closeAll() {
    document.querySelectorAll('.hni.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  }
  // Mobile : le chevron ouvre/ferme l'accordéon.
  document.addEventListener('click', function (e) {
    var ex = e.target.closest && e.target.closest('[data-lch-expand]');
    if (ex) {
      e.preventDefault();
      var hni = ex.closest('.hni');
      if (hni) hni.classList.toggle('is-open');
    }
  });
  // Éditeur de thème : ouvrir le panneau quand on sélectionne l'élément ou une colonne.
  document.addEventListener('shopify:block:select', function (e) {
    var hni = e.target.closest && e.target.closest('.hni');
    if (hni) { closeAll(); hni.classList.add('is-open'); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hni = e.target.closest && e.target.closest('.hni');
    if (hni) { hni.classList.remove('is-open'); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-klarna"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- Formatage monétaire : même implémentation que les blocs quantité --- */
    function formatWithDelimiters(cents, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(cents) || cents === null) return '0';
      var value = (cents / 100.0).toFixed(precision);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    function formatMoney(cents, fmt) {
      /* Accolades doubles construites par concatenation : ecrites en clair,
         Liquid les prendrait pour une variable et theme-check le signale. */
      fmt = fmt || ('{' + '{amount}' + '}');
      var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      var value;
      switch (placeholder) {
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function buyForm() {
      return document.querySelector('form[action*="/cart/add"]');
    }

    /* --- Prix unitaire de la variante actuellement sélectionnée --- */
    function unitPrice(el, map) {
      var form = buyForm();
      if (form) {
        var idInput = form.querySelector('[name="id"]');
        if (idInput && map[String(idInput.value)] != null) {
          return map[String(idInput.value)];
        }
      }
      return parseInt(el.getAttribute('data-unit'), 10) || 0;
    }

    /* --- Palier actif du bloc bundle ou du sélecteur de quantité --- */
    function isVisible(el) {
      return !!(el && el.offsetParent !== null);
    }

    function activeTier() {
      var all = document.querySelectorAll('[data-qbp-root], [data-qsp-root]');
      /* Si la page porte plusieurs blocs palier (bundle ET selecteur), on ne
         retient que ceux reellement affiches, sinon on lirait le palier d'un
         bloc masque et le montant serait faux. */
      var roots = [];
      for (var k = 0; k < all.length; k++) {
        if (isVisible(all[k])) roots.push(all[k]);
      }
      if (!roots.length) roots = Array.prototype.slice.call(all);

      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        var opt = root.querySelector('[data-qbp-opt].is-active, [data-qsp-opt].is-active');
        if (!opt) continue;
        return {
          qty: parseInt(opt.getAttribute('data-qty'), 10) || 1,
          pct: parseFloat(opt.getAttribute('data-pct')) || 0,
          fixed: parseInt(opt.getAttribute('data-fixed'), 10) || 0,
          type: root.getAttribute('data-disc-type') || 'percentage'
        };
      }
      return null;
    }

    /* --- Champ quantité classique du thème, si aucun bloc palier --- */
    function plainQty() {
      var form = buyForm();
      if (!form) return 1;
      var q = form.querySelector('[name="quantity"]');
      var v = q ? parseInt(q.value, 10) : 1;
      return v > 0 ? v : 1;
    }

    function computeTotal(el, map) {
      var unit = unitPrice(el, map);
      if (el.getAttribute('data-follow-qty') !== 'true') return unit;

      var tier = activeTier();
      if (tier) {
        var off = tier.type === 'fixed' ? tier.fixed : Math.round(unit * tier.pct / 100);
        var after = unit - off;
        if (after < 0) after = 0;
        return after * tier.qty;
      }
      return unit * plainQty();
    }

    function initBlock(el) {
      if (el.dataset.pklReady) return;
      el.dataset.pklReady = '1';

      var out = el.querySelector('[data-pkl-amount]');
      if (!out) return;

      var map = {};
      try { map = JSON.parse(el.getAttribute('data-variants') || '{}'); } catch (e) {}

      var n = parseInt(el.getAttribute('data-n'), 10) || 3;
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var fmt = el.getAttribute('data-money-format') || '';

      function sync() {
        var total = computeTotal(el, map);
        if (total < min) {
          el.setAttribute('hidden', '');
          return;
        }
        el.removeAttribute('hidden');
        var split = Math.ceil(total / n);
        out.textContent = n + ' x ' + formatMoney(split, fmt);
      }

      sync();

      /* Clic sur un palier : les blocs quantité basculent la classe .is-active
         juste après, donc on laisse passer un tick avant de recalculer. */
      document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('[data-qbp-opt], [data-qsp-opt]')) {
          window.setTimeout(sync, 40);
        }
      });

      /* Changement de variante ou de quantité dans le formulaire d'achat */
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
          window.setTimeout(sync, 60);
        }
      });
      document.addEventListener('input', function (e) {
        if (e.target && e.target.name === 'quantity') window.setTimeout(sync, 60);
      });
      document.addEventListener('variant:update', sync);

      /* Filet de sécurité : on observe les paliers et le formulaire */
      try {
        var watched = document.querySelectorAll('[data-qbp-root], [data-qsp-root]');
        for (var i = 0; i < watched.length; i++) {
          new MutationObserver(function () { window.setTimeout(sync, 40); }).observe(watched[i], {
            subtree: true, attributes: true, attributeFilter: ['class']
          });
        }
        var form = buyForm();
        if (form) {
          new MutationObserver(function () { window.setTimeout(sync, 60); }).observe(form, {
            subtree: true, attributes: true, attributeFilter: ['value']
          });
        }
      } catch (e) {}
    }

    function initAll() {
      var els = document.querySelectorAll('[data-pkl]');
      for (var i = 0; i < els.length; i++) initBlock(els[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-quantity-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
    function findMainForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].closest('[data-qsp-root]') && !forms[i].closest('[data-qbp-root]')) return forms[i];
      }
      return null;
    }
    function findAddButton(form) {
      var sel = 'product-form button[name="add"], button[name="add"], [type="submit"][name="add"], .product-form__submit, button.add-to-cart, [data-add-to-cart]';
      var scope = form || document;
      return scope.querySelector(sel) || (form ? form.querySelector('[type="submit"]') : null);
    }

    function initRoot(root) {
      if (root.dataset.qbpReady) return;
      root.dataset.qbpReady = '1';

      // Repli sans accolades litterales (le bloc JS doit rester 100% statique).
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-qbp-opt]'));
      var addBtn = root.querySelector('[data-qbp-add]');
      var chosenQty = 1;

      var form = findMainForm();
      var mainBtn = findAddButton(form);

      function currentId() {
        if (form) { var el = form.querySelector('[name="id"]'); if (el && el.value) return el.value; }
        return defaultId;
      }
      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        recalc();
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
          var after = unit - off; if (after < 0) after = 0;
          var total = after * qty;
          var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
          var cmpTotal = cmpUnit * qty;
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-qbp-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-qbp-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-qbp-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-qbp-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          opts[k].classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        el.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }
      var pre = root.querySelector('[data-qbp-opt].is-active') || opts[0];
      if (pre) select(pre);

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.disabled) return;
          if (form) {
            var qInput = form.querySelector('[name="quantity"]');
            if (qInput) {
              qInput.value = chosenQty;
              qInput.dispatchEvent(new Event('input', { bubbles: true }));
              qInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (mainBtn) { mainBtn.click(); flash(addBtn); }
            else if (form.requestSubmit) { form.requestSubmit(); }
            else { form.submit(); }
          } else if (defaultId) {
            var f = document.createElement('form');
            f.method = 'post'; f.action = '/cart/add';
            f.innerHTML = '<input type="hidden" name="id" value="' + defaultId + '"><input type="hidden" name="quantity" value="' + chosenQty + '">';
            document.body.appendChild(f); f.submit();
          }
        });
      }
      function flash(btn) {
        var added = btn.getAttribute('data-added');
        if (!added) return;
        var lbl = btn.querySelector('[data-qbp-label]') || btn;
        var base = btn.getAttribute('data-label') || lbl.textContent;
        lbl.textContent = added;
        setTimeout(function () { lbl.textContent = base; }, 1600);
      }

      if (form) {
        form.addEventListener('change', function () { setTimeout(syncVariant, 60); });
        try { new MutationObserver(debounce(syncVariant, 90)).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'class', 'disabled'] }); } catch (e) {}
        if (mainBtn && addBtn) {
          var sync = function () {
            var dis = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
            addBtn.disabled = dis;
          };
          sync();
          try { new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] }); } catch (e) {}
        }
      }

      syncVariant();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-qbp-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-quantity-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    function makeMoney(fmt) {
      return function (cents) {
        var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
        var name = m ? m[1] : 'amount';
        var value;
        switch (name) {
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    }
    function debounce(fn, ms) {
      var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
    }
    function findMainForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].closest('[data-qsp-root]') && !forms[i].closest('[data-qbp-root]')) return forms[i];
      }
      return null;
    }
    function findAddButton(form) {
      var sel = 'product-form button[name="add"], button[name="add"], [type="submit"][name="add"], .product-form__submit, button.add-to-cart, [data-add-to-cart]';
      var scope = form || document;
      return scope.querySelector(sel) || (form ? form.querySelector('[type="submit"]') : null);
    }

    function initRoot(root) {
      if (root.dataset.qspReady) return;
      root.dataset.qspReady = '1';

      // Repli sans accolades litterales (le bloc JS doit rester 100% statique).
      var defFmt = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
      var money = makeMoney(root.getAttribute('data-money-format') || defFmt);
      var perSuffix = root.getAttribute('data-per-suffix') || '';
      var discType = root.getAttribute('data-disc-type');
      var cmpType = root.getAttribute('data-cmp-type');
      var showCompare = root.getAttribute('data-show-compare') === 'true';
      var showPer = root.getAttribute('data-show-per') === 'true';
      var doSync = root.getAttribute('data-sync') === 'true';
      var MODE = root.getAttribute('data-mode');
      var AFTER = root.getAttribute('data-after');
      var doFix = root.getAttribute('data-fix') === 'true';
      var DEBUG = root.getAttribute('data-debug') === 'true';
      var ADD_URL = root.getAttribute('data-add-url');
      var CHANGE_URL = root.getAttribute('data-change-url');
      var CART_JS = root.getAttribute('data-cart-js');
      var CART_URL = root.getAttribute('data-cart-url');
      var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
      var compare = parseInt(root.getAttribute('data-compare'), 10) || unit;
      var defaultId = root.getAttribute('data-default-id') || '';
      var map = {};
      try { map = JSON.parse(root.getAttribute('data-variants') || '{}'); } catch (e) {}

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-qsp-opt]'));
      var addBtn = root.querySelector('[data-qsp-add]');
      var chosenQty = 1;

      var form = findMainForm();
      var mainBtn = findAddButton(form);

      function currentId() {
        if (form) { var el = form.querySelector('[name="id"]'); if (el && el.value) return el.value; }
        return defaultId;
      }
      function syncVariant() {
        var id = currentId();
        if (id && map[id]) { unit = map[id].p; compare = map[id].c; }
        recalc();
      }

      function recalc() {
        for (var k = 0; k < opts.length; k++) {
          var el = opts[k];
          var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(el.getAttribute('data-pct')) || 0;
          var fixed = parseInt(el.getAttribute('data-fixed'), 10) || 0;
          var off = discType === 'fixed' ? fixed : Math.round(unit * pct / 100);
          var after = unit - off; if (after < 0) after = 0;
          var total = after * qty;
          var cmpUnit = (cmpType === 'original' && compare > unit) ? compare : unit;
          var cmpTotal = cmpUnit * qty;
          var savings = cmpTotal - total; if (savings < 0) savings = 0;
          var pctnum = cmpTotal > 0 ? Math.round(savings * 100 / cmpTotal) : 0;

          var totalEl = el.querySelector('[data-qsp-total]');
          if (totalEl) totalEl.innerHTML = money(total);
          var cmpEl = el.querySelector('[data-qsp-compare]');
          if (cmpEl) {
            if (showCompare && savings > 0) { cmpEl.innerHTML = money(cmpTotal); cmpEl.removeAttribute('hidden'); }
            else { cmpEl.setAttribute('hidden', ''); }
          }
          var perEl = el.querySelector('[data-qsp-per]');
          if (perEl && showPer) perEl.innerHTML = money(after) + ' ' + perSuffix;
          var saveEl = el.querySelector('[data-qsp-save]');
          if (saveEl) {
            var tpl = saveEl.getAttribute('data-tpl') || '';
            saveEl.innerHTML = tpl.replace('[%]', pctnum + '%').replace('[$]', money(savings));
          }
        }
      }

      // Sans le bouton du bloc, plus rien ne transmettait la quantite : on
      // l'ecrit dans le champ quantite du theme des la selection, puis a
      // nouveau juste avant l'ajout, pour que le bouton natif envoie le bon
      // nombre d'articles.
      var warned = false;
      var injected = null;

      function log() {
        if (!DEBUG) return;
        var a = Array.prototype.slice.call(arguments);
        a.unshift('[selecteur de quantite]');
        console.log.apply(console, a);
      }

      // Certains themes pilotent leur champ quantite par un composant qui
      // surveille la propriete value. Une affectation directe passe alors
      // inapercue : on ecrit par le setter natif, que le composant voit.
      function setValue(el, v) {
        try {
          var d = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
          if (d && d.set && el.tagName === 'INPUT') { d.set.call(el, String(v)); return; }
        } catch (e) {}
        el.value = String(v);
      }

      // On cherche dans toute la page, pas seulement dans le formulaire : le
      // selecteur de quantite est souvent pose a cote, relie par l'attribut form.
      function qtyFields() {
        var out = [], all = document.querySelectorAll('input[name="quantity"], select[name="quantity"]');
        for (var i = 0; i < all.length; i++) {
          if (!all[i].closest('[data-qsp-root]') && !all[i].closest('[data-qbp-root]')) out.push(all[i]);
        }
        return out;
      }

      // Beaucoup de fiches n'affichent aucun champ quantite : le formulaire du
      // theme part alors sans quantite et Shopify retombe sur 1 article, quoi
      // qu'on fasse. Dans ce cas on lui pose nous-memes un champ cache.
      function ensureQtyField() {
        if (!form) return null;
        if (injected && form.contains(injected)) return injected;
        injected = document.createElement('input');
        injected.type = 'hidden';
        injected.name = 'quantity';
        injected.setAttribute('data-qsp-injected', '');
        form.appendChild(injected);
        log('aucun champ quantite sur la page : champ cache ajoute au formulaire du theme');
        return injected;
      }

      function pushQty() {
        if (!doSync) return;
        var list = qtyFields();
        if (!list.length) {
          var hid = ensureQtyField();
          if (hid) { hid.value = String(chosenQty); return; }
          if (!warned) { warned = true; console.warn('[selecteur de quantite] aucun formulaire produit trouve, la quantite ne peut pas etre transmise.'); }
          return;
        }
        for (var i = 0; i < list.length; i++) {
          var el = list[i];
          if (parseInt(el.value, 10) === chosenQty) continue;
          setValue(el, chosenQty);
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      var ATC_SEL = 'button[name="add"], [type="submit"][name="add"], [data-add-to-cart], .product-form__submit, button.add-to-cart';

      // Prevenir le theme que le panier a change, quel que soit le nom qu'il
      // ecoute, puis tenter d'ouvrir son tiroir s'il en a un.
      function notifyCart(open) {
        ['cart:change', 'cart:refresh', 'cart:update', 'cart:updated'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
        });
        if (!open || AFTER !== 'drawer') return;
        if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return; }
        var d = document.querySelector('cart-drawer, cart-drawer-component');
        if (d && typeof d.open === 'function') { d.open(); return; }
        var t = document.querySelector('.cart-text, [data-cart-drawer-toggle], a[href$="/cart"]');
        if (t && t.click) t.click();
      }

      // -------------------------------------------------------------------
      // Lecture du panier reel. Sert de reference avant un ajout fait par le
      // theme, et permet de corriger la ligne si la quantite n'a pas suivi.
      // -------------------------------------------------------------------
      var lastCart = null;

      function pullCart() {
        return fetch(CART_JS, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { lastCart = c; return c; })
          .catch(function () { return null; });
      }

      function lineFor(cart, id) {
        var q = 0, key = null;
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].id) !== String(id)) continue;
            q += cart.items[i].quantity;
            if (!key) key = cart.items[i].key;
          }
        }
        return { qty: q, key: key };
      }

      // Filet : le theme vient d'ajouter, on verifie ce qui est reellement
      // arrive dans le panier et on remet la bonne quantite si besoin.
      function repair(id, want, before) {
        var tries = 0;
        (function poll() {
          tries++;
          setTimeout(function () {
            pullCart().then(function (c) {
              if (!c) return;
              var now = lineFor(c, id);
              if (!now.key || now.qty <= before) { if (tries < 8) poll(); return; }
              if (now.qty >= before + want) return;
              log('le theme a ajoute', now.qty - before, 'article(s) au lieu de', want, ': correction');
              fetch(CHANGE_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: now.key, quantity: before + want })
              })
                .then(function (r) { return r.json(); })
                .then(function (c2) { lastCart = c2; notifyCart(false); })
                .catch(function (err) { console.error('[selecteur de quantite]', err); });
            });
          }, 400);
        })();
      }

      // Le bloc prend l'ajout en charge : le formulaire du theme ne transporte
      // qu'une quantite qu'il lit a sa facon, et selon les themes elle ne suit
      // pas. Ici on envoie nous-memes la variante et la quantite au panier.
      function addSelf(btn) {
        var id = parseInt(currentId(), 10);
        if (!id) return false;
        // On ne touche pas au libelle du bouton du theme : il contient souvent
        // des icones ou des noeuds que le theme reecrit lui-meme.
        function busy(on) {
          if (!btn) return;
          btn.disabled = on;
          if (on) btn.setAttribute('aria-busy', 'true');
          else btn.removeAttribute('aria-busy');
        }
        busy(true);
        fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: chosenQty }] })
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (d) {
              if (!r.ok) throw new Error(d.description || d.message || 'Ajout refusé');
              return d;
            });
          })
          .then(function () {
            busy(false);
            log('ajout par le bloc :', chosenQty, 'article(s), variante', id);
            pullCart();
            notifyCart(true);
            if (AFTER === 'cart') { window.location.href = CART_URL; return; }
            if (AFTER === 'reload') { window.location.reload(); return; }
          })
          .catch(function (err) {
            busy(false);
            console.error('[selecteur de quantite]', err);
          });
        return true;
      }

      // Le theme garde la main : on lui pousse la quantite, puis on verifie.
      var lastRelay = 0;
      function relay() {
        pushQty();
        // Le clic puis le submit declenchent tous les deux : une seule verification.
        var now = new Date().getTime();
        if (now - lastRelay < 1500) return;
        lastRelay = now;
        if (!doFix || chosenQty < 2 || !lastCart) return;
        var id = currentId();
        if (!id) return;
        repair(id, chosenQty, lineFor(lastCart, id).qty);
      }

      function intercept(e) {
        if (e.__qspDone) return;
        var t = null;
        if (e.type === 'submit') {
          t = e.target;
          if (!t || !t.matches || !t.matches('form[action*="/cart/add"]')) return;
        } else {
          t = e.target && e.target.closest ? e.target.closest(ATC_SEL) : null;
        }
        if (!t || root.contains(t)) return;
        e.__qspDone = true;
        if (MODE !== 'block') { relay(); return; }
        // Sans variante utilisable on ne bloque rien : le theme fait son travail.
        if (!parseInt(currentId(), 10)) { relay(); return; }
        // En capture sur window, donc avant tout gestionnaire du theme.
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        addSelf(e.type === 'submit' ? null : t);
      }

      window.addEventListener('click', intercept, true);
      window.addEventListener('submit', intercept, true);

      // Diagnostic a taper dans la console : qspDiag()
      window.qspDiag = function () {
        var info = {
          mode: MODE,
          formulaireProduit: form ? (form.getAttribute('action') || 'form') : 'INTROUVABLE',
          boutonDuTheme: mainBtn ? (mainBtn.tagName + '.' + (mainBtn.className || '')) : 'INTROUVABLE',
          champsQuantite: qtyFields().length,
          champCacheAjoute: !!injected,
          quantiteChoisie: chosenQty,
          variante: currentId(),
          correctionPanier: doFix,
          panierLu: !!lastCart
        };
        console.table ? console.table(info) : console.log(info);
        return info;
      };

      function select(el) {
        for (var k = 0; k < opts.length; k++) {
          opts[k].classList.remove('is-active');
          opts[k].setAttribute('aria-pressed', 'false');
        }
        el.classList.add('is-active');
        el.setAttribute('aria-pressed', 'true');
        chosenQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        pushQty();
      }

      for (var k = 0; k < opts.length; k++) {
        (function (el) { el.addEventListener('click', function () { select(el); }); })(opts[k]);
      }
      var pre = root.querySelector('[data-qsp-opt].is-active') || opts[0];
      if (pre) select(pre);

      // Bouton propre : règle la quantité de la page puis relaie le vrai bouton d'achat.
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.disabled) return;
          if (form) {
            var qInput = form.querySelector('[name="quantity"]');
            if (qInput) {
              qInput.value = chosenQty;
              qInput.dispatchEvent(new Event('input', { bubbles: true }));
              qInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (mainBtn) { mainBtn.click(); flash(addBtn); }
            else if (form.requestSubmit) { form.requestSubmit(); }
            else { form.submit(); }
          } else if (defaultId) {
            // Repli hors page produit : POST direct /cart/add
            var f = document.createElement('form');
            f.method = 'post'; f.action = '/cart/add';
            f.innerHTML = '<input type="hidden" name="id" value="' + defaultId + '"><input type="hidden" name="quantity" value="' + chosenQty + '">';
            document.body.appendChild(f); f.submit();
          }
        });
      }
      function flash(btn) {
        var added = btn.getAttribute('data-added');
        if (!added) return;
        var lbl = btn.querySelector('[data-qsp-label]') || btn;
        var base = btn.getAttribute('data-label') || lbl.textContent;
        lbl.textContent = added;
        setTimeout(function () { lbl.textContent = base; }, 1600);
      }

      // Suivi de la variante choisie sur la page (prix d'affichage).
      if (form) {
        form.addEventListener('change', function () { setTimeout(syncVariant, 60); });
        try { new MutationObserver(debounce(syncVariant, 90)).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'class', 'disabled'] }); } catch (e) {}
        // Reflète l'état épuisé sur notre bouton.
        if (mainBtn && addBtn) {
          var sync = function () {
            var dis = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
            addBtn.disabled = dis;
          };
          sync();
          try { new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] }); } catch (e) {}
        }
      }

      syncVariant();

      // Etat du panier avant tout ajout : c'est la reference du filet de securite.
      pullCart().then(function () {
        log('mode', MODE,
          '| formulaire', form ? 'trouve' : 'INTROUVABLE',
          '| bouton du theme', mainBtn ? (mainBtn.className || mainBtn.tagName) : 'INTROUVABLE',
          '| champs quantite', qtyFields().length);
      });
      document.addEventListener('cart:change', function () { setTimeout(pullCart, 300); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-qsp-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-stories"] && !Shopify.designMode) return;
  try {
    (function () {
  function player(root) { return root.querySelector('[data-pstories-player]'); }
  function setLabel(btn, txt) { var l = btn.querySelector('[data-pstories-add-label]'); if (l) { l.textContent = txt; } else { btn.textContent = txt; } }

  function showCards(root) {
    var st = root._pst; if (!st || !st.groups) return;
    st.groups.forEach(function (g, i) {
      if (i === st.index) {
        g.hidden = false;
        g.scrollLeft = 0;
        g.style.animation = 'none';
        void g.offsetWidth;
        g.style.animation = '';
        Array.prototype.slice.call(g.querySelectorAll('[data-pstories-add]')).forEach(function (btn) {
          btn.disabled = false;
          setLabel(btn, btn.getAttribute('data-default') || 'Ajouter au panier');
        });
      } else {
        g.hidden = true;
      }
    });
    var dlg = player(root);
    var active = st.groups[st.index];
    var multi = active && active.classList.contains('has-multiple');
    Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-cardnav]')).forEach(function (b) { b.hidden = !multi; });
  }

  function setBars(root) {
    var st = root._pst; if (!st || !st.bars) return;
    st.bars.forEach(function (bar, i) {
      var fill = bar.firstElementChild; if (!fill) return;
      fill.style.transform = 'scaleX(' + (i < st.index ? 1 : 0) + ')';
    });
  }

  function show(root) {
    var st = root._pst; if (!st) return;
    var dlg = player(root);
    var b = st.bubbles[st.index];
    var video = dlg.querySelector('[data-pstories-video]');
    video.pause();
    video.setAttribute('src', b.getAttribute('data-video') || '');
    video.currentTime = 0;
    video.play().catch(function () {});
    var t = dlg.querySelector('[data-pstories-ptitle]');
    if (t) t.textContent = b.getAttribute('data-title') || '';
    var av = dlg.querySelector('[data-pstories-avatar]');
    if (av) { var a = b.getAttribute('data-avatar'); if (a) { av.src = a; av.style.display = ''; } else { av.style.display = 'none'; } }
    setBars(root);
    showCards(root);
  }

  function step(root, dir) {
    var st = root._pst; if (!st) return;
    st.index = (st.index + dir + st.bubbles.length) % st.bubbles.length;
    show(root);
  }

  function bind(root) {
    var dlg = player(root);
    if (!dlg || dlg._pstBound) return;
    dlg._pstBound = true;
    var video = dlg.querySelector('[data-pstories-video]');
    dlg.addEventListener('close', function () { video.pause(); video.removeAttribute('src'); video.load(); });
    video.addEventListener('ended', function () { step(root, 1); });
    video.addEventListener('click', function () { if (video.paused) { video.play().catch(function () {}); } else { video.pause(); } });
    video.addEventListener('timeupdate', function () {
      var st = root._pst; if (!st || !st.bars || !video.duration) return;
      var bar = st.bars[st.index]; if (!bar) return;
      var fill = bar.firstElementChild; if (!fill) return;
      fill.style.transform = 'scaleX(' + Math.min(video.currentTime / video.duration, 1) + ')';
    });
  }

  function open(root, index) {
    var dlg = player(root); if (!dlg) return;
    root._pst = {
      bubbles: Array.prototype.slice.call(root.querySelectorAll('[data-pstories-open]')),
      bars: Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-bar]')),
      groups: Array.prototype.slice.call(dlg.querySelectorAll('[data-pstories-cards]')),
      index: index
    };
    bind(root);
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    show(root);
  }

  document.addEventListener('click', function (e) {
    var bubble = e.target.closest('[data-pstories-open]');
    if (bubble) {
      var root = bubble.closest('[data-pstories]');
      var bubbles = Array.prototype.slice.call(root.querySelectorAll('[data-pstories-open]'));
      open(root, bubbles.indexOf(bubble));
      return;
    }
    var nav = e.target.closest('[data-pstories-nav]');
    if (nav) { step(nav.closest('[data-pstories]'), parseInt(nav.getAttribute('data-pstories-nav'), 10)); return; }
    var close = e.target.closest('[data-pstories-close]');
    if (close) { var d = close.closest('dialog'); if (d) d.close(); return; }
    var cnav = e.target.closest('[data-pstories-cardnav]');
    if (cnav) {
      var croot = cnav.closest('[data-pstories]');
      var cst = croot._pst; if (!cst) return;
      var cg = cst.groups[cst.index]; if (!cg) return;
      var ccard = cg.querySelector('.pstories__card');
      var cw = ccard ? (ccard.offsetWidth + 10) : cg.clientWidth;
      cg.scrollBy({ left: parseInt(cnav.getAttribute('data-pstories-cardnav'), 10) * cw, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest('[data-pstories-add]');
    if (add) {
      var id = add.getAttribute('data-variant'); if (!id) return;
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add'); }
        return r.json();
      }).then(function () {
        setLabel(add, add.getAttribute('data-added') || 'Ajouté ✓');
        document.dispatchEvent(new CustomEvent('pstories:added', { bubbles: true }));
        if (add.getAttribute('data-after') === 'cart') { window.location.href = '/cart'; }
      }).catch(function () {
        add.disabled = false;
        setLabel(add, 'Réessayer');
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["usage-detail"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__udInit) return;
  window.__udInit = true;

  var current = null;
  var lastFocus = null;
  var editorOpen = false;

  function scrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function open(root, fromEditor) {
    if (current && current !== root) close(current, true);
    root.classList.add('is-open');
    var card = root.parentElement.querySelector('.ud-card');
    if (card) card.setAttribute('aria-expanded', 'true');
    current = root;
    editorOpen = !!fromEditor;
    if (!fromEditor) {
      lastFocus = document.activeElement;
      document.documentElement.style.setProperty('--ud-sbw', scrollbarWidth() + 'px');
      document.documentElement.classList.add('ud-lock');
      var closeBtn = root.querySelector('.ud-close');
      if (closeBtn) closeBtn.focus();
    }
  }

  function close(root, silent) {
    root.classList.remove('is-open');
    var card = root.parentElement.querySelector('.ud-card');
    if (card) card.setAttribute('aria-expanded', 'false');
    if (current === root) {
      document.documentElement.classList.remove('ud-lock');
      if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
      current = null;
      editorOpen = false;
    }
  }

  function rootFromEvent(el) {
    if (!el || !el.closest) return null;
    var root = el.closest('.ud-drawer-root');
    if (root) return root;
    var wrap = el.closest('.ud-card-wrap');
    return wrap ? wrap.querySelector('.ud-drawer-root') : null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.ud-card');
    if (trigger) {
      var wrap = trigger.closest('.ud-card-wrap');
      var root = wrap && wrap.querySelector('.ud-drawer-root');
      if (root) { e.preventDefault(); open(root, false); }
      return;
    }
    if (e.target.closest && (e.target.closest('.ud-close') || e.target.classList.contains('ud-backdrop'))) {
      var r = e.target.closest('.ud-drawer-root');
      if (r) close(r, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') { close(current, false); return; }
    if (e.key === 'Tab') {
      var f = current.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = rootFromEvent(e.target);
    if (root) open(root, true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = rootFromEvent(e.target);
    if (root && editorOpen) close(root, true);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
